export default __webpack_public_path__ + "static/NotoSans-Bold.subset-42bab048c27d2a267127f38505400f1e.woff";